import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed/inventory')({
  component: InventoryRouteLayout,
});

function InventoryRouteLayout() {
  return <Outlet />;
}
